import React, { FC, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { InputBaseContainer, InputSelectWithLabel } from '../molecules';
import { useGetVocabularyCountyQuery } from '../redux/rtkQuery/apiSlice';

type Props = {
  control:any,
  errors:any,
  getValues:Function,
  setValue:Function,
  openTop?: boolean,
  watch?: any,
}
const JurisdictionFormCounty:FC<Props> = ({ openTop = true, control, errors, getValues, setValue, watch }) => {
  const { data, isLoading } = useGetVocabularyCountyQuery({});
  const [counties, setCounties] = useState([]);
  const [stateValue, setStateValue] = useState('FL');
  const name = 'county';
  const _state = watch('state');

  useEffect(() => {
    if (_state) {
      setStateValue(_state);
    }
  }, [_state]);
  useEffect(() => {
    let filteredCounties = [];
    if (data) {
      if (stateValue) {
        const stateAbr = stateValue.id || stateValue;
        filteredCounties = data.results.filter(c => c.state === stateAbr);
      }

      if (_state) {
        const stateAbr = _state.id;
        filteredCounties = data.results.filter(c => c.state === stateAbr);
      }

      setCounties(filteredCounties);
      const county = getValues(name);
      const _countyObj = data.results.find(r => r.name === county);
      if (_countyObj) {
        setValue(name, _countyObj);
      }
    }
  }, [data, _state]);

  return (
    <InputBaseContainer>
      <Controller
        name={name}
        defaultValue=""
        control={control}
        render={props => (
          <InputSelectWithLabel
            selectAllActive
            placeholder=""
            menuPlacement={openTop ? "top" : "auto"}
            isLoading={isLoading}
            label="County"
            error={errors.county}
            isDisabled={false}
            getOptionValue={(item: any) => item.id || Math.random()}
            getOptionLabel={(item: any) => item.name}
            isRequired
            options={counties}
            {...props}
          />
        )}
      />
    </InputBaseContainer>
  );
};

export default JurisdictionFormCounty;
